import { Box, Button, Container } from "@material-ui/core";
import { formatTimestamp } from "swyft-react-core";
import { Link } from "react-router-dom";
import { useStyles } from "../../quoteDetail.styles";
import { QuoteTable } from "./QuoteTable";
import { Quote } from "../../../../api/Quote/Quote";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { EQuoteStatus } from "../../../../api/Quote/EQuoteStatus";
import { quoteDepositAmount } from "../../../../app/utils";

export const QuoteQuotation = ({ quote }: { quote: Quote }) => {
  const { isMoreThanMd, isMoreThanSm } = useBreakpoint();
  const classes = useStyles();

  return (
    <Container maxWidth={"lg"}>
      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        pt={isMoreThanMd ? 0 : "60px"}
        justifyContent={"center"}
      >
        <Box
          bgcolor={"#fff"}
          width={"100%"}
          boxShadow={"0 5px 15px 0 rgba(0, 0, 0, 0.07)"}
          maxWidth={"740px"}
          borderRadius={"4px"}
        >
          <Box
            display={"flex"}
            flexDirection={isMoreThanSm ? "row" : "column"}
            fontSize={"14px"}
            justifyContent={"space-between"}
            fontWeight={400}
            width={"100%"}
            color="#4b5462"
            padding={isMoreThanSm ? "34px 10px 19px 48px" : "34px 24px 29px 33px"}
          >
            <Box
              display="flex"
              marginRight={isMoreThanSm ? "66px" : 0}
              mb={isMoreThanSm ? 0 : "20px"}
              width={"auto"}
              justifyContent={"space-between"}
            >
              <Box>Ref No:</Box>
              <Box ml={1}>{quote.name}</Box>
            </Box>
            <Box display="flex" mr={isMoreThanSm ? 2.6 : 0} width={"auto"} justifyContent={"space-between"}>
              <Box>Valid until:</Box>
              <Box ml={1}>{formatTimestamp(quote.expiry || quote.created + 30 * 24 * 60 * 60 * 1000)}</Box>
            </Box>
          </Box>
          <QuoteTable quote={quote} />
          {quote.status === EQuoteStatus.Sent ? (
            <Box display={"flex"} mt={1} flexDirection={"column"} alignItems={"center"} justifyContent={"center"}>
              <Button
                component={Link}
                to={`/checkout/${quote.id}`}
                variant="contained"
                color="secondary"
                className={classes.btnBookNow}
              >
                Book Now
              </Button>
              <Box
                fontSize={isMoreThanSm ? "14px" : "12px"}
                maxWidth={isMoreThanSm ? "100%" : "272px"}
                textAlign={"center"}
                color={"#939393"}
                mt="15px"
                mb="48px"
              >
                Book your installation with a €{quoteDepositAmount(quote)} deposit to secure your price
              </Box>
            </Box>
          ) : (
            <Box mb="16px" />
          )}
        </Box>
      </Box>
    </Container>
  );
};
